import { Helmet } from 'react-helmet-async';
import MemberCard from './components/MemberCard';
import MemberSwipe from './components/MemberSwipe';
import MyCouponButton from './components/MyCouponButton';

const MemberPage = () => {
  return (
    <>
      <Helmet>
        <title>Member | Caltex StarCard</title>
      </Helmet>
      <MemberCard />
      <MyCouponButton />
      <MemberSwipe />
    </>
  );
};

export default MemberPage;
